import { UeContainer } from '@oneaudi/falcon-tools';
import { NavigationBar } from '@oneaudi/unified-web-components';
import React, { useContext, useEffect, useRef } from 'react';
import styled from 'styled-components';
import { Context } from '../../../context/Context';
import { useI18n } from '../../../i18n';
import { attachHorizontalNavigation } from '../../../utils/a11y';
import { LeftContainer, RightContainer, StyledMainMenu } from '../SubPageNavigationStyles';
import CtaSection from '../ui/CtaSection';
import SubmenuTrigger from '../ui/SubmenuTrigger';
import { useTrackingManager } from '../../../utils/useTrackingManager';
import { useBreakpoint } from '../../../utils/useBreakpoint';

const CenterContainer = styled.div`
  display: none;

  @media (min-width: ${({ theme }) => theme.breakpoints.xl}px) {
    display: block;
    min-width: 0;
  }
`;

/**
 * Yes this div seems unnecessary, but it is really needed.
 * If removed the NavigationBar component struggles to calculate it's correct size.
 * Only remove if you're 100% certain what you're doing.
 */
const NavigationBarWrapper = styled.div`
  width: 100%;
`;

const MainMenu: React.FC = () => {
  const {
    hasCta,
    content: { links },
    linkCount,
    ctaCount,
  } = useContext(Context);
  const { click } = useTrackingManager();
  const { breakpoint } = useBreakpoint();

  const menuRef = useRef<HTMLElement>(null);
  const navRef = useRef<HTMLDivElement | null>(null);

  const ariaLabel = useI18n('ariaMenu');
  const ariaScrollLeft = useI18n('ariaScrollLeft');
  const ariaScrollRight = useI18n('ariaScrollRight');

  useEffect(() => {
    if (menuRef.current) {
      attachHorizontalNavigation(menuRef.current);
    }
  }, []);

  return (
    <StyledMainMenu aria-label={ariaLabel} ref={menuRef}>
      <LeftContainer>
        <SubmenuTrigger />
      </LeftContainer>
      <CenterContainer>
        <NavigationBarWrapper>
          <UeContainer propertyPath="links" label="Sub Pages">
            <NavigationBar
              id="mainMenuNavbar"
              scrollButtons={{
                left: {
                  ariaLabel: ariaScrollLeft,
                  onClick: () =>
                    click('arrow', 'Left', '', '', breakpoint, '', linkCount, ctaCount),
                },
                right: {
                  ariaLabel: ariaScrollRight,
                  onClick: () =>
                    click('arrow', 'Right', '', '', breakpoint, '', linkCount, ctaCount),
                },
              }}
              size="sm"
              items={links.map((link, i) => ({
                active: link.currentPage === true,
                label: link.text,
                href: link.href,
                onClick: () => {
                  click('link', link.text, link.href, `${i + 1}`, breakpoint, '');
                },
              }))}
              className="subpage-navigation-bar"
              ref={navRef}
            />
          </UeContainer>
        </NavigationBarWrapper>
      </CenterContainer>
      {hasCta && (
        <RightContainer>
          <CtaSection />
        </RightContainer>
      )}
    </StyledMainMenu>
  );
};

export default MainMenu;
